import React, { useState, useEffect, useRef } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const decadeData = [
  {
    id: '1980s-1990s',
    title: '1980s–1990s',
    summary: 'YFT Group began operations in Dubai in Bur Dubai & Naif Road, Deira through early retail trading, expanding distribution operations and sourcing networks across Asia',
    heroImage: 'https://images.unsplash.com/photo-1441986300917-64674bd600d8',
    decades: ['1980s', '1990s'],
    events: [
      { year: '1980', description: 'Began operations in Dubai through early retail trading and wholesale garment activity in Bur Dubai & Naif Road, Deira', tag: 'Retail and Distribution', logo: null },
      { year: '1980–1989', description: 'Established roots in Bur Dubai & Naif Road, Deira and expanded local garment wholesale', tag: 'Retail and Distribution', logo: null },
      { year: '1990–1999', description: 'Expanded Distribution operations throughout GCC', tag: 'Retail and Distribution', logo: null },
      { year: '1990–1999', description: 'Strengthened sourcing networks across Asia', tag: 'Retail and Distribution', logo: null }
    ]
  },
  {
    id: '2000-2014',
    title: '2000–2014',
    summary: 'Launched Cash & Carry stores across Dubai, established partnerships with Lulu and Carrefour, and secured exclusive distribution rights for Jockey and Hanes',
    heroImage: 'https://images.unsplash.com/photo-1555529669-e69e7aa0ba9a',
    decades: ['2000s', '2010s'],
    events: [
      { year: '2000', description: 'Launched Cash & Carry stores in Dubai', tag: 'Retail and Distribution', logo: null },
      { year: '2001–2008', description: 'Began supplying international retail chains and hypermarkets across the Middle East', tag: 'Retail and Distribution', logo: null },
      { year: '2001–2008', description: 'Expanded partnerships with regional retailers including Lulu, Carrefour, Centrepoint, and other supermarket groups', tag: 'Retail and Distribution', logo: 'https://customer-assets.emergentagent.com/job_luxury-dubai-1/artifacts/c1euoar1_Lulu.png', logoScale: 1.5 },
      { year: '2009', description: 'Opened the Jawed Habib hair salon franchise in Dubai', tag: 'Hair and beauty', logo: 'https://customer-assets.emergentagent.com/job_luxury-dubai-1/artifacts/f5kmd47e_jawed%20habib.png', logoScale: 1.5 },
      { year: '2012', description: 'Launched Cottny Retail Stores, an in-house Fashion Brand', tag: 'Retail and Distribution', logo: 'https://customer-assets.emergentagent.com/job_luxury-dubai-1/artifacts/7zhzh9zv_cottny.jpeg', logoScale: 1.5 },
      { year: '2014', description: 'Gained exclusive distribution rights for Jockey in the UAE', tag: 'Retail and Distribution', logo: 'https://customer-assets.emergentagent.com/job_luxury-dubai-1/artifacts/1s3dvidx_jockey.png', logoScale: 1.5 },
      { year: '2014', description: 'Opened multiple Jockey franchise stores across the UAE', tag: 'Retail and Distribution', logo: 'https://customer-assets.emergentagent.com/job_luxury-dubai-1/artifacts/1s3dvidx_jockey.png', logoScale: 1.5 }
    ]
  },
  {
    id: '2015-2021',
    title: '2015–2021',
    summary: 'Expanded operations to Nigeria and Kenya, securing major licensing partnerships with Disney, Marvel, Warner Bros, Universal Studios and FIFA World Cup merchandise across MENA region',
    heroImage: 'https://images.unsplash.com/photo-1582066344029-c81555d28cae',
    decades: ['2010s', '2020s'],
    events: [
      { year: '2016', description: 'Secured exclusive distribution rights for Hanes in the UAE', tag: 'Retail and Distribution', logo: 'https://customer-assets.emergentagent.com/job_luxury-dubai-1/artifacts/6sgpfy78_Hanes.png', logoScale: 1.5 },
      { year: '2017', description: 'Secured Licensing rights for Hasbro, Rovio & Moose across MENA region for Apparels', tag: 'Retail and Distribution', logo: null },
      { year: '2018', description: 'Secured Licensing rights for Emoji across MENA region for Apparels', tag: 'Retail and Distribution', logo: null },
      { year: '2018', description: 'Opened Nigeria office', tag: 'Retail and Distribution', logo: null },
      { year: '2018', description: 'Secured licensing rights for FIFA World Cup Russia across MENA', tag: 'Retail and Distribution', logo: 'https://customer-assets.emergentagent.com/job_luxury-dubai-1/artifacts/hlylds68_Fifa.png', logoScale: 1.0 },
      { year: '2019', description: 'Launched Kenya office', tag: 'Retail and Distribution', logo: null },
      { year: '2019', description: 'Gained exclusive distribution rights for Rupa Innerwear in UAE, Nigeria, and Kenya', tag: 'Retail and Distribution', logo: null },
      { year: '2020', description: 'Secured licensing rights for Disney, Marvel & Warner Bros across MENA region', tag: 'Retail and Distribution', logo: 'https://customer-assets.emergentagent.com/job_luxury-dubai-1/artifacts/lqzatl68_disney.webp', logoScale: 1.0 },
      { year: '2020', description: 'Secured licensing rights for Universal Studios across MENA region', tag: 'Retail and Distribution', logo: null },
      { year: '2021', description: 'Secured licensing rights for Peanuts and Pink Panther across MENA region', tag: 'Retail and Distribution', logo: null }
    ]
  },
  {
    id: '2022-present',
    title: '2022–Present',
    summary: 'Diversified into residential and commercial real estate, rebranded Crossover Bollywood salon, and expanded into manufacturing and electric vehicle production',
    heroImage: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab',
    decades: ['2020s'],
    events: [
      { year: '2020', description: 'Secured distribution rights for American Garden in Nigeria', tag: 'Retail and Distribution', logo: 'https://customer-assets.emergentagent.com/job_luxury-dubai-1/artifacts/tsssnnot_american.jpg', logoScale: 1.5 },
      { year: '2020', description: 'Secured distribution rights for Britannia in Nigeria', tag: 'Retail and Distribution', logo: null },
      { year: '2020', description: 'Launched medical supplies division providing face masks and gloves during COVID relief', tag: 'Retail and Distribution', logo: null },
      { year: '2024', description: 'Secured Distribution rights for Patanjali for Nigeria', tag: 'Retail and Distribution', logo: null },
      { year: '2024', description: 'Secured Distribution rights for Bombay Shaving Co for MENA region', tag: 'Retail and Distribution', logo: null },
      { year: '2025', description: 'Rebranded Crossover Bollywood into a unisex Bollywood-inspired salon concept in Dubai', tag: 'Hair and beauty', logo: null },
      { year: '2025', description: 'Expanded residential and commercial real estate portfolio under OAMS Property Management', tag: 'Real estate and development', logo: null },
      { year: '2025', description: 'Secured distribution rights for Lucina, Lido for Nigeria', tag: 'Retail and Distribution', logo: null },
      { year: '2026 onward', description: 'Expanded into manufacturing, assembly, and mobility-related production for electric vehicles', tag: 'Manufacturing', logo: 'https://customer-assets.emergentagent.com/job_luxury-dubai-1/artifacts/w98nl3e8_omega%20seiki.png', logoScale: 1.8 },
      { year: '2026 onward', description: 'Will launch Ali Café & Ali Tea in Nigeria (distribution rights already secured)', tag: 'Retail and Distribution', logo: null }
    ]
  }
];

export const LegacyCarousel = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const [visibleItems, setVisibleItems] = useState([]);
  const timeoutRef = useRef(null);

  // Auto-advance carousel
  useEffect(() => {
    if (!isPaused) {
      timeoutRef.current = setTimeout(() => {
        setCurrentSlide((prev) => (prev + 1) % decadeData.length);
        setVisibleItems([]);
      }, 10000);
    }
    return () => clearTimeout(timeoutRef.current);
  }, [currentSlide, isPaused]);

  // Animate items when slide changes
  useEffect(() => {
    const currentEvents = decadeData[currentSlide].events;
    currentEvents.forEach((_, index) => {
      setTimeout(() => {
        setVisibleItems((prev) => [...prev, index]);
      }, index * 100);
    });
  }, [currentSlide]);

  const goToSlide = (index) => {
    // Prevent clicking the same slide again
    if (index === currentSlide) return;
    setCurrentSlide(index);
    setVisibleItems([]);
  };

  return (
    <section id="legacy" className="section-padding" style={{ background: 'var(--bg-secondary)', position: 'relative', overflow: 'hidden' }}>
      <div className="container">
        <div style={{ textAlign: 'center', marginBottom: '60px' }}>
          <h2 className="heading-1">A legacy built on enterprise and growth</h2>
          <div className="gold-line" style={{ margin: '24px auto' }} />
        </div>

        {/* Decade Headers */}
        <div style={{ display: 'flex', justifyContent: 'center', gap: '24px', marginBottom: '40px', flexWrap: 'wrap' }}>
          {decadeData.map((decade, index) => (
            <button
              key={decade.id}
              onClick={() => goToSlide(index)}
              style={{
                background: currentSlide === index ? 'var(--accent-gold)' : 'transparent',
                color: currentSlide === index ? 'var(--bg-primary)' : 'var(--text-primary)',
                border: `2px solid ${currentSlide === index ? 'var(--accent-gold)' : 'var(--border-light)'}`,
                padding: '12px 32px',
                borderRadius: '8px',
                fontSize: '16px',
                fontWeight: currentSlide === index ? 600 : 400,
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                fontFamily: 'var(--font-serif)'
              }}
              onMouseEnter={(e) => {
                if (currentSlide !== index) {
                  e.currentTarget.style.borderColor = 'var(--accent-gold)';
                  e.currentTarget.style.color = 'var(--accent-gold)';
                }
              }}
              onMouseLeave={(e) => {
                if (currentSlide !== index) {
                  e.currentTarget.style.borderColor = 'var(--border-light)';
                  e.currentTarget.style.color = 'var(--text-primary)';
                }
              }}
            >
              {decade.title}
            </button>
          ))}
        </div>

        {/* Carousel Container */}
        <div
          style={{ maxWidth: '1100px', margin: '0 auto', position: 'relative' }}
          onMouseEnter={() => setIsPaused(true)}
          onMouseLeave={() => setIsPaused(false)}
        >
          <div style={{ overflow: 'hidden', position: 'relative' }}>
            <div
              style={{
                display: 'flex',
                transform: `translateX(-${currentSlide * 100}%)`,
                transition: 'transform 0.6s ease-in-out'
              }}
            >
              {decadeData.map((decade, slideIndex) => (
                <div
                  key={decade.id}
                  style={{
                    minWidth: '100%',
                    padding: '0 20px'
                  }}
                >
                  {/* Hero Image */}
                  {decade.heroImage && (
                    <div style={{ 
                      width: '100%', 
                      height: '200px', 
                      borderRadius: '12px', 
                      overflow: 'hidden',
                      marginBottom: '32px',
                      position: 'relative'
                    }}>
                      <img 
                        src={decade.heroImage} 
                        alt={`${decade.title} era`}
                        style={{ 
                          width: '100%', 
                          height: '100%', 
                          objectFit: 'cover',
                          filter: 'brightness(0.8)'
                        }} 
                      />
                      <div style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        background: 'linear-gradient(to bottom, rgba(0,0,0,0.3), rgba(0,0,0,0.1))',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}>
                        <h3 className="heading-2" style={{ color: '#ffffff', fontSize: '32px', textShadow: '2px 2px 4px rgba(0,0,0,0.5)' }}>
                          {decade.title}
                        </h3>
                      </div>
                    </div>
                  )}

                  {/* Decade Summary */}
                  <div style={{ textAlign: 'center', marginBottom: '40px' }}>
                    <p className="body-large" style={{ color: 'var(--text-secondary)', maxWidth: '800px', margin: '0 auto' }}>
                      {decade.summary}
                    </p>
                  </div>

                  {/* Timeline */}
                  <div style={{ 
                    position: 'relative', 
                    paddingBottom: '20px',
                    minHeight: slideIndex <= 1 ? 'auto' : undefined,
                    maxHeight: slideIndex <= 1 ? 'fit-content' : undefined
                  }}>
                    {/* Vertical Line - Extends through all events */}
                    <div
                      style={{
                        position: 'absolute',
                        left: '50%',
                        top: 0,
                        bottom: 0,
                        width: '2px',
                        background: 'var(--border-light)',
                        transform: 'translateX(-50%)',
                        zIndex: 0
                      }}
                      className="timeline-line"
                    />

                    {/* Timeline Events */}
                    {decade.events.map((event, index) => {
                      const isEven = index % 2 === 0;
                      const isVisible = visibleItems.includes(index);
                      
                      return (
                        <div
                          key={index}
                          style={{
                            position: 'relative',
                            marginBottom: index < decade.events.length - 1 ? '30px' : '0',
                            opacity: isVisible ? 1 : 0,
                            transform: isVisible ? 'translateY(0)' : 'translateY(20px)',
                            transition: 'all 0.5s ease',
                            display: 'grid',
                            gridTemplateColumns: '1fr 60px 1fr',
                            gap: '0',
                            alignItems: 'center',
                            zIndex: 1
                          }}
                          className="timeline-event"
                        >
                          {/* Left Side */}
                          <div style={{ textAlign: 'right', paddingRight: '20px' }}>
                            {isEven ? (
                              <span
                                className="heading-3"
                                style={{
                                  color: 'var(--accent-gold)',
                                  fontWeight: 600,
                                  fontSize: '18px'
                                }}
                              >
                                {event.year}
                              </span>
                            ) : (
                              <div
                                style={{
                                  textAlign: 'left',
                                  padding: '12px 16px',
                                  background: 'var(--bg-primary)',
                                  borderRadius: '8px',
                                  border: '1px solid var(--border-light)',
                                  transition: 'all 0.3s ease',
                                  position: 'relative'
                                }}
                                className="timeline-card"
                              >
                                <span
                                  style={{
                                    fontSize: '10px',
                                    color: '#ffffff',
                                    background: 'var(--accent-gold)',
                                    padding: '3px 8px',
                                    borderRadius: '3px',
                                    fontWeight: 600,
                                    display: 'inline-block',
                                    marginBottom: '6px'
                                  }}
                                >
                                  {event.tag}
                                </span>
                                <p
                                  className="body-regular"
                                  style={{
                                    color: 'var(--text-primary)',
                                    lineHeight: '1.6',
                                    margin: 0,
                                    fontSize: '14px'
                                  }}
                                >
                                  {event.description}
                                </p>
                              </div>
                            )}
                          </div>

                          {/* Center Dot with Optional Logo */}
                          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px' }}>
                            {event.logo ? (
                              <div
                                style={{
                                  width: '48px',
                                  height: '48px',
                                  borderRadius: '50%',
                                  background: '#ffffff',
                                  border: '3px solid var(--accent-gold)',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  overflow: 'hidden',
                                  transition: 'all 0.5s ease',
                                  zIndex: 2,
                                  opacity: isVisible ? 1 : 0,
                                  padding: '4px'
                                }}
                              >
                                <img 
                                  src={event.logo} 
                                  alt="Brand logo"
                                  style={{ 
                                    width: event.logoScale ? `${event.logoScale * 100}%` : '100%', 
                                    height: event.logoScale ? `${event.logoScale * 100}%` : '100%', 
                                    objectFit: 'contain',
                                    maxWidth: '200%',
                                    maxHeight: '200%'
                                  }} 
                                />
                              </div>
                            ) : (
                              <div
                                style={{
                                  width: '16px',
                                  height: '16px',
                                  borderRadius: '50%',
                                  background: isVisible ? 'var(--accent-gold)' : 'var(--bg-secondary)',
                                  border: '3px solid var(--accent-gold)',
                                  transition: 'all 0.5s ease',
                                  zIndex: 2
                                }}
                              />
                            )}
                          </div>

                          {/* Right Side */}
                          <div style={{ textAlign: 'left', paddingLeft: '20px' }}>
                            {isEven ? (
                              <div
                                style={{
                                  textAlign: 'left',
                                  padding: '12px 16px',
                                  background: 'var(--bg-primary)',
                                  borderRadius: '8px',
                                  border: '1px solid var(--border-light)',
                                  transition: 'all 0.3s ease',
                                  position: 'relative'
                                }}
                                className="timeline-card"
                              >
                                <span
                                  style={{
                                    fontSize: '10px',
                                    color: '#ffffff',
                                    background: 'var(--accent-gold)',
                                    padding: '3px 8px',
                                    borderRadius: '3px',
                                    fontWeight: 600,
                                    display: 'inline-block',
                                    marginBottom: '6px'
                                  }}
                                >
                                  {event.tag}
                                </span>
                                <p
                                  className="body-regular"
                                  style={{
                                    color: 'var(--text-primary)',
                                    lineHeight: '1.6',
                                    margin: 0,
                                    fontSize: '14px'
                                  }}
                                >
                                  {event.description}
                                </p>
                              </div>
                            ) : (
                              <span
                                className="heading-3"
                                style={{
                                  color: 'var(--accent-gold)',
                                  fontWeight: 600,
                                  fontSize: '18px'
                                }}
                              >
                                {event.year}
                              </span>
                            )}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Progress Indicators */}
        <div style={{ display: 'flex', justifyContent: 'center', gap: '12px', marginTop: '40px' }}>
          {decadeData.map((_, index) => (
            <button
              key={index}
              onClick={() => goToSlide(index)}
              style={{
                width: currentSlide === index ? '32px' : '12px',
                height: '12px',
                borderRadius: '6px',
                background: currentSlide === index ? 'var(--accent-gold)' : 'var(--border-light)',
                border: 'none',
                cursor: 'pointer',
                transition: 'all 0.3s ease'
              }}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>
      </div>

      <style>{`
        @media (max-width: 768px) {
          .timeline-event {
            grid-template-columns: auto 1fr !important;
            gap: 16px !important;
          }
          
          .timeline-event > div:first-child {
            display: none !important;
          }
          
          .timeline-event > div:nth-child(2) {
            position: absolute;
            left: 16px;
          }
          
          .timeline-event > div:last-child {
            margin-left: 48px;
          }
          
          .timeline-line {
            left: 24px !important;
            transform: none !important;
          }
        }

        .timeline-card:hover {
          background: #ffffff !important;
          border-color: var(--accent-gold) !important;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08) !important;
        }
      `}</style>
    </section>
  );
};
